import React  from 'react';

import { FaFacebookF, FaInstagram, FaLinkedin, FaPhone, FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
    return (
        <>
            <footer >
                <div className="px-5 copyright d-flex align-items-center justify-content-between flex-md-row flex-column-reverse">
                    <p className='mb-0 text-light text-center fs-6'>Copyrights
                        <span style={{ fontFamily: 'sans-serif' }}> &copy;</span>  {new Date().getFullYear()} All Rights Reserved </p>


                    <div className='d-flex align-items-center my-md-0 my-4'>

                        <a href="https://www.facebook.com/zithastechnologiesuk" aria-label="facebook link" target='_blank' rel="noreferrer" className='footer-social-icon'>
                            <FaFacebookF />
                        </a>

                        <a href="https://twitter.com/zithasuk" aria-label="twitter link" target='_blank' rel="noreferrer" className='footer-social-icon'>
                            <FaXTwitter />

                        </a>

                        <a href="https://www.instagram.com/zithastechnologies.uk/" aria-label='linkedIn link' target='_blank' rel="noreferrer" className='footer-social-icon'>
                            <FaInstagram />
                        </a>

                        <a href="https://www.linkedin.com/company/zithas-technologies-uk" aria-label='linkedIn link' target='_blank' rel="noreferrer" className='footer-social-icon'>
                            <FaLinkedin />
                        </a>
                    </div>

                    <p className='mb-0 d-flex align-items-center text-light mt-md-0 mt-3  fs-6'>Call Us :
                        <a href={'tel:(0) 7767 426142'} className="d-flex align-items-center ms-3">
                            <FaPhone className="me-2" />
                            <span className='fw-semibold'> (0) 7767 426142</span>
                        </a>
                    </p>
                </div>
            </footer>
        </>
    )
}

export default Footer;